import * as actionTypes from './actionTypes';
import * as actions from './index';

export const getSeriesTree = () => {
	return dispatch => {
		dispatch({ type: actionTypes.SERIES_LOAD_START });

		try {
			window.flow.seriesGetTree().then(res => {
				console.log(res);
				dispatch({ type: actionTypes.SERIES_LOAD_SUCCESS, data: res });
				res.tree.forEach(item => {
					dispatch(seriesGetClipById(item.id, item.type));
				});
			}).catch(res => {
				dispatch({ type: actionTypes.SERIES_LOAD_FAIL });
				dispatch(actions.applicationError(res.message));
			});
		} catch (err) {
			console.log("seriesGetTree does not exists!");
		}

	};
};


export const seriesGetClipById = (id, type) => {
	return dispatch => {
		switch (type) {
			case "series_program":
				window.flow.seriesGetProgramById(id).then(res => {
					let clips = { [res.id]: res };
					dispatch({ type: actionTypes.SERIES_GET_CLIPS_SUCCESS, clips: clips });
				}).catch(res => {
					console.log(res);
				});
				break;
			case "series_series":
				window.flow.seriesGetSeriesById(id).then(res => {
					let clips = { [res.id]: res };
					dispatch({ type: actionTypes.SERIES_GET_CLIPS_SUCCESS, clips: clips });
				}).catch(res => {

				});
				break;
			case "series_season":
				window.flow.seriesGetSeasonById(id).then(res => {
					let clips = { [res.id]: res };
					dispatch({ type: actionTypes.SERIES_GET_CLIPS_SUCCESS, clips: clips });
				}).catch(res => {

				});
				break;
			case "series_episode":
				window.flow.seriesGetEpisodeById(id).then(res => {
					let clips = { [res.id]: res };
					dispatch({ type: actionTypes.SERIES_GET_CLIPS_SUCCESS, clips: clips });
				}).catch(res => {

				});
				break;
			default:
				break;
		}
	}
}

export const seriesGetClipsByParent = (id, type) => {
	return dispatch => {
		switch (type) {
			case "series_program":
				window.flow.seriesGetSeasonByFields([{ field: '_series_parent', type: '=', value: id }]).then(res => {
					let clips = res.objects.elements;
					dispatch({ type: actionTypes.SERIES_GET_CLIPS_SUCCESS, clips: clips });
				}).catch(res => {
					console.log(res);
				});
				break;
			case "series_series":
				window.flow.seriesGetEpisodeByFields([{ field: '_series_parent', type: '=', value: id }]).then(res => {
					let clips = res.objects.elements;
					dispatch({ type: actionTypes.SERIES_GET_CLIPS_SUCCESS, clips: clips });
				}).catch(res => {
					console.log(res);
				});
				break;
			case "series_season":
				window.flow.seriesGetEpisodeByFields([{ field: '_series_parent', type: '=', value: id }]).then(res => {
					let clips = res.objects.elements;
					dispatch({ type: actionTypes.SERIES_GET_CLIPS_SUCCESS, clips: clips });
				}).catch(res => {

				});
				break;
			case "series_episode":
				// nothing to do - episode is not a parent
				break;
			default:
				break;
		}
	}
}

export const setActiveSeries = (series) => {
	return dispatch => {
		dispatch({ type: actionTypes.SERIES_SET_ACTIVE, series: series });
		if (series) {
			dispatch(seriesGetClipsByParent(series.id, series.type));
		}
	};
};
